import React from "react"; // useEffect, // useState,

import parse from "html-react-parser";
import { useTranslation } from "react-i18next";

import "./index.css";

export default function RQuestion(props) {
  const {
    t,
    // i18n
  } = useTranslation("translation");

  const lang = "en";

  return (
    <div className="rhetoricalQuestion">
      <div className="heading">
        {props.data.heading !== ""
          ? parse(t(`${props.data.heading}.string`))
          : props.data.questions.length < 2
            ? t(`RhetoricalQ.string`)
            : t(`RhetoricalQs.string`)}
      </div>
      <div className="questions-rhetorical">
        {props.data.questions.map((question, key) => {
          return (
            <div key={key} className="questionData-rhetorical">
              <div className="question-rhetorical">
                {parse(t(`${question.question}.string`))}
              </div>
              {question.image.imageURL !== "" ? (
                <div>
                  <img
                    src={
                      props.preview
                        ? question.image.imageURL
                        : window.location.origin +
                          window.location.pathname +
                          `locales/${lang}/images/${question.image.src}`
                    }
                    style={{
                      minHeight:
                        props.preview && props.data.imageURL !== ""
                          ? "100px"
                          : null,
                      minWidth:
                        props.preview && props.data.imageURL !== ""
                          ? "100%"
                          : null,
                    }}
                    alt={
                      question.image.alt !== ""
                        ? t(`${question.image.alt}.string`)
                        : ""
                    }
                    className="question-rhetorical-image"
                  />
                </div>
              ) : null}
            </div>
          );
        })}
      </div>
    </div>
  );
}
